/* CuDeToate v3.3 — product tile runtime.
 *
 * Only job: turn the server-rendered delivery-promise placeholder into a real
 * promise. The wording depends on the wall clock relative to the shop cut-off,
 * and tile markup is CDN-cached, so it cannot be rendered in Liquid without
 * going stale.
 *
 * Cut-off hour is published by layout/theme.liquid as window.CDT_CUTOFF_HOUR
 * and must stay in step with assets/deliveryEstimate.js, which drives the
 * product page.
 */
(function () {
  'use strict';
  if (window.__cdtTile) return;
  window.__cdtTile = 1;

  var CUTOFF = typeof window.CDT_CUTOFF_HOUR === 'number' ? window.CDT_CUTOFF_HOUR : 15;

  function isWeekend(d) {
    var n = d.getDay();
    return n === 0 || n === 6;
  }

  /* Next day the warehouse actually ships, given "now". */
  function nextBusinessDay(from) {
    var d = new Date(from.getTime());
    do {
      d.setDate(d.getDate() + 1);
    } while (isWeekend(d));
    return d;
  }

  function cutoffLabel() {
    return (CUTOFF < 10 ? '0' + CUTOFF : CUTOFF) + ':00';
  }

  /* Returns the promise as two parts, because it does not fit one line in a
     tile column and a ragged break lands mid-phrase. `lead` is the condition
     the shopper has to meet, `hit` is what they get for meeting it — set
     muted and emphasised respectively, so the arrival still reads at a
     glance when the sentence wraps. Joined with a space they are the same
     sentence as before. */
  function promise() {
    var now = new Date();
    var beforeCutoff = !isWeekend(now) && now.getHours() < CUTOFF;

    if (beforeCutoff) {
      /* Ships today -> arrives the next business day. Stating the deadline
         rather than a ticking countdown: it is the same information, reads
         as a shop policy instead of a pressure timer, and does not change
         between two glances at the same page. */
      return {
        lead: 'Comandă până la ora ' + cutoffLabel() + ' · ',
        hit: 'livrare ' + arrivalWord(nextBusinessDay(now))
      };
    }
    /* Missed today's dispatch: ships next business day, arrives the one after.
       No deadline is quoted here — today's has passed, and promising against
       tomorrow's cut-off would be a different, longer sentence for no gain. */
    return { lead: '', hit: 'Livrare ' + arrivalWord(nextBusinessDay(nextBusinessDay(now))) };
  }

  function promiseKey() {
    var p = promise();
    return p.lead + p.hit;
  }

  var DAYS = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];

  function arrivalWord(target) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var t = new Date(target.getTime());
    t.setHours(0, 0, 0, 0);
    var days = Math.round((t - today) / 86400000);
    if (days <= 1) return 'mâine';
    if (days === 2) return 'poimâine';
    return DAYS[t.getDay()];
  }

  function paint(root) {
    var nodes = (root || document).querySelectorAll('[data-cdt-eta-text]:not([data-cdt-eta-done])');
    if (!nodes.length) return;
    var p = promise();
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var lead = node.querySelector('[data-cdt-eta-lead]');
      var hit = node.querySelector('[data-cdt-eta-hit]');
      if (lead && hit) {
        lead.textContent = p.lead;
        hit.textContent = p.hit;
      } else {
        /* Older markup that has not been split into the two spans yet. */
        node.textContent = p.lead + p.hit;
      }
      node.setAttribute('data-cdt-eta-done', '1');
    }
  }

  function start() {
    paint(document);
    /* Infinite scroll and the recommendation rails inject tiles after load. */
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(function () { paint(document); }, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
    /* The sentence is now constant inside a cut-off window, so there is
       nothing to tick. The only event worth repainting for is the clock
       crossing the cut-off (or midnight) during a long session — so compare
       the text first and touch the DOM only when it genuinely changed. */
    var last = promiseKey();
    setInterval(function () {
      var next = promiseKey();
      if (next === last) return;
      last = next;
      var all = document.querySelectorAll('[data-cdt-eta-done]');
      for (var i = 0; i < all.length; i++) all[i].removeAttribute('data-cdt-eta-done');
      paint(document);
    }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ---------------------------------------------------------------------------
   Tile quick-add ("Adaugă în coș" on product cards).

   MOVED HERE 2026-08-28. This delegated handler previously lived as an inline
   <script> inside sections/collection__main.liquid and sections/search__main.liquid
   ONLY — but the button it listens for is emitted by
   snippets/product-thumbnail__product-info.liquid, which is rendered from nine
   places: cdt-product-row (homepage), index__featured-collection,
   product__recommendations, also-bought, index__reco-rail, reco-card,
   product-slider, cdt-wishlist-card and include-mega-menu.

   So on every surface EXCEPT collection and search pages the button rendered,
   looked like the primary buy action, and did nothing at all when tapped — no
   request, no error, no navigation. Verified live on the homepage: 3 buttons,
   window.__cdtQAdd undefined, click produced zero /cart/add requests.

   cdt-tile.js is loaded globally (layout/theme.liquid), so binding here covers
   every surface. The __cdtQAdd guard is kept so a stray second copy is a no-op
   rather than a double-add.
   --------------------------------------------------------------------------- */
(function () {
  if (window.__cdtQAdd) return; window.__cdtQAdd = 1;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cdt-qadd[data-variant]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = 'Se adaugă...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: btn.getAttribute('data-variant'), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.textContent = '✓ Adăugat';
        if (window.cdxCartUpdated) window.cdxCartUpdated();
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1500);
      })
      .catch(function () {
        btn.textContent = orig; btn.disabled = false;
        alert('A apărut o eroare. Încercați din nou.');
      });
  });
})();
